import React from 'react';
import './LearningStyle.css';
import pencilIcon from "../assets/pencil.png";

const ClassCard = ({ data }) => {
  return (
    <div className="class-card">
      <h3 className="class-card-title">{data.title}</h3>
      <div className="class-card-details">
        {data.details.map((detail, index) => (
          <div className="detail-row" key={index}>
            <p className="detail-label">{detail.label}</p>
            <p className="detail-value" title={detail.value}>
              {detail.value.length > 30 ? detail.value.substring(0, 25) + '...' : detail.value}
            </p>
          </div>
        ))}
      </div>
      <br></br>
      <button className="pocustom-btn yellow-btn">
                          <img src={pencilIcon} alt="icon" className="pobtn-icon" />
                          Book Free Demo Class
                        </button>
    </div>
  );
};

const LearningStyle = () => {
  const privateClassData = {
    title: "Private 1-on-1 Class",
    details: [
      { label: "Class duration", value: "60 minutes" },
      { label: "Class type", value: "Individual" },
      { label: "Class schedule", value: "Flexible" },
      { label: "Learning mode", value: "With teacher" },
      { label: "Pace of learning", value: "Personalized" },
      { label: "Activities", value: "With teacher" },
      { label: "Assessment", value: "Individual" },
    ]
  };

  const groupClassData = {
    title: "Group Classes",
    details: [
      { label: "Class duration", value: "60 minutes" },
      { label: "Class type", value: "Small Group" },
      { label: "Class schedule", value: "Peer dependent" },
      { label: "Learning mode", value: "With teacher and fellow Polymaths" },
      { label: "Pace of learning", value: "Group" },
      { label: "Activities", value: "With teacher and fellow Polymaths" },
      { label: "Assessment", value: "Individual and as a team" },
    ]
  };

  return (
    <div className="learning-style-container">
      <h2 className="learning-style-heading">
        Choose the learning style that <span>suits your child best</span>
      </h2>
      <div className="learning-style-cards">
        <ClassCard data={privateClassData} />
        <ClassCard data={groupClassData} />
      </div>
    </div>
  );
};

export default LearningStyle;